module.exports = __webpack_public_path__ + "static/media/Colette Stripe Single Headboard - 120 cm_White.3864206f.png";